"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuComponent = void 0;
const React = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const icons_1 = __importDefault(require("constants/icons"));
const model_1 = require("constants/model");
const hooks_1 = require("components/hooks");
const url_1 = require("utils/url");
const context_1 = require("components/context");
const version_1 = require("constants/version");
const useMenu_1 = __importDefault(require("components/hooks/useMenu"));
const MenuComponent = props => {
    const { navigation } = props;
    const authContext = React.useContext(context_1.AuthContext);
    const client = (0, hooks_1.useClient)();
    const menuItemCloseMenu = (0, native_base_1.useBreakpointValue)({
        base: {
            id: model_1.ConfigMenu.MENU,
            name: "",
            icon: icons_1.default.icMenu,
        },
        md: {},
    });
    const [menuItems, setMenuItems] = (0, useMenu_1.default)();
    if (menuItems?.find(menuItem => menuItem.id == model_1.ConfigMenu.SIGN_OUT) == null)
        menuItems?.push({ id: model_1.ConfigMenu.SIGN_OUT, name: theme_1.Str.signOff, parent: false });
    if (menuItems?.find(menuItem => menuItem.id == model_1.ConfigMenu.USER) == null)
        menuItems?.unshift({
            id: model_1.ConfigMenu.USER,
            name: authContext?.loginData?.name ?? "",
            icon: icons_1.default.icUserWithBack,
        });
    if (menuItems?.find(menuItem => menuItem.id == model_1.ConfigMenu.MENU) == null && menuItemCloseMenu.id == model_1.ConfigMenu.MENU)
        menuItems?.unshift(menuItemCloseMenu);
    if (false && menuItems?.find(menuItem => menuItem.id == model_1.ConfigMenu.PARENT_ORDERS) != null) {
        //add submenu called "Pendientes"
        //validate if pendientes already exists
        if (menuItems
            ?.find(menuItem => menuItem.id == model_1.ConfigMenu.PARENT_ORDERS)
            ?.subs?.find(menuItem => menuItem.id == model_1.ConfigMenu.ORDERS_PENDING) == null)
            menuItems
                ?.find(menuItem => menuItem.id == model_1.ConfigMenu.PARENT_ORDERS)
                ?.subs?.push({
                id: model_1.ConfigMenu.ORDERS_PENDING,
                name: "Pendientes",
                icon: icons_1.default.icOrders,
                selected: true,
            });
        //setMenuItems(menuItems);
    }
    const onMenuItemClick = (menu) => {
        if (client == null && menu.id !== model_1.ConfigMenu.SIGN_OUT)
            return;
        if (menu.parent == false)
            props.onMenuItemClick(menu.id ?? "");
        if (menu.parent == true) {
            menu.showSub = !(menu.showSub == true);
        }
        navigation.setParams({});
        setMenuItems(menuItems);
    };
    const onMenuItemSubClick = (menu, menuSub) => {
        if (client == null && menu.id !== model_1.ConfigMenu.SIGN_OUT)
            return;
        props.onMenuItemClick(menuSub.id ?? "");
        menuItems?.flatMap(e => e.subs ?? [])?.forEach(e => (e.selected = false));
        menuSub.selected = true;
        navigation.setParams({});
        setMenuItems(menuItems);
    };
    const MenuComponents = menuItems?.map(item => {
        switch (item.id) {
            case model_1.ConfigMenu.PLANNING:
                item.icon = icons_1.default.icProducts;
                break;
            case model_1.ConfigMenu.QUOTE:
                item.icon = icons_1.default.icQuote;
                break;
            case model_1.ConfigMenu.ORDERS:
                item.icon = icons_1.default.icOrders;
                break;
            case model_1.ConfigMenu.ACCOUNT_STATES:
                item.icon = icons_1.default.icAccountStates;
                break;
            case model_1.ConfigMenu.INVOICES:
                item.icon = icons_1.default.icInvoice;
                break;
            case model_1.ConfigMenu.SUPPORT:
                item.icon = icons_1.default.icUserHeadPhones;
                break;
            case model_1.ConfigMenu.MY_ORDERS:
                item.icon = icons_1.default.icOrders;
                break;
            case model_1.ConfigMenu.REQUIREMENT:
                item.icon = icons_1.default.icRequirement;
                break;
            case model_1.ConfigMenu.UPLOAD_EXCEL:
                item.icon = icons_1.default.icOrders;
                break;
            case model_1.ConfigMenu.BTU_GESTION:
                item.icon = icons_1.default.icBtu;
                break;
            case model_1.ConfigMenu.BTU_SALE:
                item.icon = icons_1.default.icBtu;
                break;
            case model_1.ConfigMenu.BTU_HISTORY:
                item.icon = icons_1.default.icBtu;
                break;
            case model_1.ConfigMenu.BTU_DISCOUNT:
                item.icon = icons_1.default.icSettings;
                break;
            case model_1.ConfigMenu.BTU_PRICES:
                item.icon = icons_1.default.icBtuPrice;
                break;
            case model_1.ConfigMenu.SIGN_OUT:
                item.icon = icons_1.default.icXInsideCircle;
                break;
            default:
                item.icon = item.icon;
                break;
        }
        if (item.id == model_1.ConfigMenu.SIGN_OUT) {
            return <MenuItemSignOff key={item.id + "-" + item} menu={item} onMenuItemClick={onMenuItemClick}/>;
        }
        return (<MenuItem key={item.id + "-" + item} menu={item} onMenuItemClick={onMenuItemClick} onMenuItemSubClick={onMenuItemSubClick}/>);
    });
    if (MenuComponents == null)
        return <></>;
    return (<native_base_1.VStack style={styles.container}>
			{__DEV__ && (0, url_1.isLocalhost)() && (<native_base_1.Text bg="colorVividRed1" p="10" color="white">
					{(0, url_1.getUserTypeFromUrl)()}
				</native_base_1.Text>)}

			{MenuComponents}
			<native_base_1.VStack px="43" flex="1" justifyContent="flex-end">
				<native_base_1.Text color="white">{`v${version_1.APP_VERSION}`}</native_base_1.Text>
			</native_base_1.VStack>
		</native_base_1.VStack>);
};
exports.MenuComponent = MenuComponent;
const MenuItem = ({ menu, onMenuItemClick, onMenuItemSubClick }) => {
    const onMenuItemSubClickInternal = (submenu) => {
        onMenuItemSubClick(menu, submenu);
    };
    const subMenuIndex = menu.subs?.findIndex(e => e.selected);
    const arrowHeight = ((subMenuIndex ?? 0) + 1) * 14 + (subMenuIndex ?? 0) * 12;
    //console.log("subMenuIndex", subMenuIndex, "menu", menu.name, "aHeight", arrowHeight);
    {
        /*
        py={show ? 25 : 0}
            h={show ? "auto" : 0}
            opacity={show ? 1 : 0}
        */
    }
    return (<native_base_1.VStack>
			<native_base_1.Pressable style={stylesMenuItem.container} py={15} onPress={() => {
            react_native_1.LayoutAnimation.spring();
            onMenuItemClick?.(menu);
        }}>
				<native_base_1.Image source={{ uri: menu.icon }} style={[
            stylesMenuItem.icon,
            (menu.id == model_1.ConfigMenu.MENU || (menu.selected && menu.parent == false)) && {
                tintColor: theme_1.Colors.colorVividYellow1,
            },
        ]} alt={menu.name}/>
				<native_base_1.Text style={[
            stylesMenuItem.txtTitle,
            {
                color: menu.selected && menu.parent == false ? theme_1.Colors.colorVividYellow1 : "white",
            },
        ]}>
					{menu.name ?? ""}
				</native_base_1.Text>
			</native_base_1.Pressable>

			{menu.showSub == true && (<native_base_1.ZStack>
					{menu.subs?.map(submenu => (<MenuItemSub menu={submenu} onMenuItemClick={onMenuItemSubClickInternal}/>))}

					<native_base_1.View key={arrowHeight} ml={43}>
						<native_base_1.Image key={arrowHeight + (subMenuIndex ?? 0)} style={{
                width: "21px",
                height: arrowHeight,
                resizeMode: (subMenuIndex ?? 0) > 0 ? "repeat" : "contain",
            }} source={{ uri: icons_1.default.icArrowSubmenuLine, width: 21, height: 100, cache: "reload" }}/>
						{/*
                        <View
                        bgColor={"#B5B5B5"}
                        style={{width: "2px", marginRight: "4.5px"}}
                        h={arrowHeight}
                    />
                     */}
						{/* <View
                        bgColor={"rgba(181, 181, 181, 0.9)"}
                        style={{width: "0.0265px"}}
                        borderRadius={10}
                        h={arrowHeight}
                        mr={2}
                    />*/}
					</native_base_1.View>
				</native_base_1.ZStack>)}

			{menu.showSub == true && <native_base_1.View mb={20}/>}
		</native_base_1.VStack>);
};
const MenuItemSignOff = ({ menu, onMenuItemClick }) => {
    const [isHovered, setIsHovered] = React.useState(false);
    return (<native_base_1.Pressable style={stylesMenuItem.container} py={15} onPress={() => {
            react_native_1.LayoutAnimation.spring();
            onMenuItemClick?.(menu);
        }} onHoverIn={() => setIsHovered(true)} onHoverOut={() => setIsHovered(false)}>
			<native_base_1.HStack>
				<native_base_1.View w={25} h={25} mr={10}>
					<native_base_1.Image w={25} h={25} source={icons_1.default.icXInsideCircle}/>
				</native_base_1.View>

				<native_base_1.View flex={1} px={2}>
					<native_base_1.Text flex={1} fontSize={14} color="white">
						{isHovered ? "Cerrar  Sesión" : ""}
					</native_base_1.Text>
				</native_base_1.View>
			</native_base_1.HStack>
		</native_base_1.Pressable>);
};
const MenuItemSub = ({ menu, onMenuItemClick }) => {
    const [isHovered, setIsHovered] = React.useState(false);
    {
        /*
        py={show ? 25 : 0}
            h={show ? "auto" : 0}
            opacity={show ? 1 : 0}
        */
    }
    return (<native_base_1.Pressable style={stylesMenuItem.container} onHoverIn={() => setIsHovered(true)} onHoverOut={() => setIsHovered(false)} onPress={() => {
            react_native_1.LayoutAnimation.spring();
            onMenuItemClick?.(menu);
        }} flexDir="row">
			<native_base_1.HStack>
				<native_base_1.View mr={10} style={{
            width: "21px",
            height: "28px",
        }}>
					{(isHovered || menu.selected) && (<native_base_1.Image style={{
                width: "21px",
                height: "28px",
                resizeMode: "stretch",
                tintColor: isHovered && menu.selected != true ? theme_1.Colors.colorDarkGray1 : "#B5B5B5",
            }} resizeMode="stretch" source={icons_1.default.icArrowSubmenu}/>)}
				</native_base_1.View>

				<native_base_1.HStack flex={1} borderRadius={7} bg={menu.selected == true ? "#8B8B8C" : ""} px={2} alignItems="center">
					<native_base_1.Image source={icons_1.default.icDot} w={4} h={4} mr={5}/>
					<native_base_1.Text flex={1} color={menu.selected ? "black" : "white"} fontSize={18}>
						{menu.name ?? ""}
					</native_base_1.Text>
				</native_base_1.HStack>
			</native_base_1.HStack>
		</native_base_1.Pressable>);
};
const styles = react_native_1.StyleSheet.create({
    container: {
        height: "100%",
        paddingVertical: 25,
    },
});
const stylesMenuItem = react_native_1.StyleSheet.create({
    container: {
        paddingHorizontal: 43,
        flexDirection: "row",
        alignItems: "center",
    },
    icon: {
        width: 19,
        height: 19,
        marginEnd: 12,
    },
    txtTitle: {
        flex: 1,
        color: "white",
        fontSize: 18,
        fontFamily: theme_1.Fonts.bold,
    },
});
exports.default = exports.MenuComponent;
